import { css } from 'lit';
import { IxRadio } from './IxRadio.js';

export class IxRadioStyled extends IxRadio {
  static override styles = css`
    ::slotted([slot='description']) {
      margin-block-start: 0;
      margin-block-end: 0;
    }
    label {
      align-items: center;
      display: flex;
      gap: var(--ix-checkbox-radio-gap, 0.5rem);
      line-height: var(--ix-radio-label-line-height, 2.625rem);
    }
    .description {
      display: block;
      margin: var(--ix-radio-margin, 0);
      font-weight: var(
        --ix-radio-font-weight,
        var(--text-caption-weight, normal)
      );
      font-size: var(--ix-radio-font-size, var(--text-caption-size, 0.75rem));
      line-height: var(
        --ix-radio-line-height,
        var(--text-caption-line-height, 1.33333333em)
      );
      letter-spacing: var(
        --ix-radio-letter-spacing,
        var(--text-caption-letter-spacing, 0.03333333em)
      );
      color: var(--ix-radio-color, var(--clr-on-surface, #092241));
      padding: var(--ix-radio-padding, 0 0 0 28px);
    }
    [disabled] {
      color: var(
        --ix-radio-clr-disabled,
        var(--clr-on-surface-disabled, #09224180)
      );
    }
  `;
}

window.customElements.define('ix-radio', IxRadioStyled);
